import { Button, Input } from 'antd';
import { ModalWrap } from '../../component/modal-wrap';
import { useState } from 'react';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly onOk: () => Promise<boolean>;
  readonly children: React.ReactNode;
  readonly onClose?: () => void;
  readonly width?: string;
  readonly oKText?: string;
  readonly cancelText?: string;
  readonly title?: React.ReactNode | string;
  readonly className?: string;
  readonly footer?: React.ReactNode;
  readonly loading?: boolean;
  readonly targetValue: string;
}

export const DelConfirmModal = (props: IProps) => {
  const [val, setVal] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const onOk = async () => {
    if (val === props.targetValue) {
      setLoading(true);
      const res = await props.onOk();
      setLoading(false);
      return res;
    }
    return false;
  };

  const onClose = () => {
    props?.onClose && props.onClose();
  };

  const renderChildren = () => {
    return (
      <>
        {props.children}
        <Input
          value={val}
          onChange={(e) => setVal(e.target.value)}
          type="string"
          placeholder={getFormatMessage('please_enter')}
        />
      </>
    );
  };

  const disabled = val !== props.targetValue;
  return (
    <ModalWrap
      {...props}
      onOk={onOk}
      onClose={() => onClose()}
      oKText={
        <Button
          loading={loading}
          onClick={onOk}
          className="gc-btn gc-btn-primary btn-admin"
          danger
          disabled={disabled}
        >
          {getFormatMessage('delete')}
        </Button>
      }
      okButtonProps={{ danger: true }}
      title={props.title || ''}
    >
      {renderChildren()}
    </ModalWrap>
  );
};
